import React from 'react';
import styled from 'styled-components';

const SkeletonCarousel = styled.div`
  width: 100%;
  height: 700px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 8px;
  margin-top: 10px;

  @keyframes loading {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }

  @media (max-width: 768px) {
    height: 250px;
    margin-top: 0;
  }
`;

const SkeletonProductOfWeek = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: 15px;
  border-radius: 8px;
  margin-top: 10px;
  min-height: 700px;

  @media (max-width: 768px) {
    margin-top: 15px;
    min-height: 350px;
  }
`;

const SkeletonTitle = styled.div`
  width: 90%;
  height: 32px;
  margin: 0 auto 15px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;

  @keyframes loading {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }

  @media (max-width: 1340px) {
    height: 25px;
  }

  @media (max-width: 768px) {
    height: 32px;
  }
`;

const SkeletonProductImage = styled.div`
  width: 400px;
  height: 400px;
  margin: 10px auto;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;

  @keyframes loading {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }

  @media (max-width: 1250px) {
    width: 150px;
    height: 150px;
  }

  @media (max-width: 990px) {
    width: 130px;
    height: 130px;
  }

  @media (max-width: 768px) {
    width: 200px;
    height: 200px;
  }

  @media (max-width: 425px) {
    width: 150px;
    height: 150px;
  }
`;

const SkeletonProductName = styled.div`
  width: 90%;
  height: 24px;
  margin: 10px auto 5px;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;

  @keyframes loading {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }

  @media (max-width: 1250px) {
    height: 20px;
  }

  @media (max-width: 768px) {
    height: 24px;
  }
`;

const SkeletonPrice = styled.div`
  width: 50%;
  height: 28px;
  margin: 10px auto;
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 4px;

  @keyframes loading {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }

  @media (max-width: 1250px) {
    height: 22px;
  }

  @media (max-width: 950px) {
    height: 18px;
  }

  @media (max-width: 768px) {
    height: 28px;
  }
`;

const SkeletonButton = styled.div`
  width: 60%;
  height: 40px;
  margin: 15px auto 10px;
  background: linear-gradient(90deg, #9cc54b 25%, #8ab03f 50%, #9cc54b 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  border-radius: 10px;

  @keyframes loading {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }

  @media (max-width: 960px) {
    height: 35px;
  }

  @media (max-width: 768px) {
    height: 40px;
  }
`;

/**
 * HeroSkeleton Component
 * Used within Bootstrap col-md-7 col-lg-8 for carousel
 * Used within Bootstrap col-md-5 col-lg-4 for product of the week
 * The parent handles the row/col layout
 */
const HeroSkeleton = ({type = 'carousel'}) => {
	if (type === 'productOfWeek') {
		return (
			<SkeletonProductOfWeek>
				<SkeletonTitle/>
				<SkeletonProductImage/>
				<SkeletonProductName/>
				<SkeletonPrice/>
				<SkeletonButton/>
			</SkeletonProductOfWeek>
		);
	}

	return <SkeletonCarousel/>;
};

export default React.memo(HeroSkeleton);
